const chartNumberFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 1,
});

export function formatChartNumber(value: number) {
  return chartNumberFormatter.format(value);
}
